import op028 from './op028'
import op101 from './op101'
import op106 from './op106'
import op108 from './op108'
import op140 from './op140'

export default {
  op028,
  op101,
  op106,
  op108,
  op140
}